
import {
    PAQUETEGENERAL_LOADING,
    PAQUETEGENERAL_LOADED,
    PAQUETEGENERAL_ERROR,

    PAQUETEINDI_LOADING,
    PAQUETEINDI_LOADED,
    PAQUETEINDI_ERROR,
  
    PAQUETEINDI2_LOADING,
    PAQUETEINDI2_LOADED,
    PAQUETEINDI2_ERROR,   

    PAQUETE_LOADING,
    PAQUETE_LOADED,
    PAQUETE_ERROR,
    
    CREARPAQUETE_ERROR,
    CREARPAQUETE_LOADED,
    CREARPAQUETE_LOADING,
    
    EDITARPAQUETE_ERROR,
    EDITARPAQUETE_LOADED,
    EDITARPAQUETE_LOADING,
    
    DELETEPAQUETE_ERROR,
    DELETEPAQUETE_LOADED,
    DELETEPAQUETE_LOADING,

    VERSION_PAQUETE_ERROR,
    VERSION_PAQUETE_LOADED,
    VERSION_PAQUETE_LOADING,
    
    COLABORADOR_PAQUETE_ERROR,
    COLABORADOR_PAQUETE_LOADED,
    COLABORADOR_PAQUETE_LOADING,
    
    COMPRADOR_PAQUETE_ERROR,
    COMPRADOR_PAQUETE_LOADED,
    COMPRADOR_PAQUETE_LOADING,
    
    ESPECIE_PAQUETE_ERROR,
    ESPECIE_PAQUETE_LOADED,
    ESPECIE_PAQUETE_LOADING,

    CREAR_VERSION_PAQUETE_ERROR,
    CREAR_VERSION_PAQUETE_LOADED,
    CREAR_VERSION_PAQUETE_LOADING,

    PAQUETE_HOME_LOADING,
    PAQUETE_HOME_LOADED,
    PAQUETE_HOME_ERROR,

    PAQUETE_INDIVIDUAL_LOADING,
    PAQUETE_INDIVIDUAL_LOADED,
    PAQUETE_INDIVIDUAL_ERROR,

    VALORACION_LOADING,
    VALORACION_LOADED,
    VALORACION_ERROR,
    VALORACION_PAQUETE_LIKE,
    REVERTIR_VALORACION_LIKE,
    VALORACION_PAQUETE_INDIVIDUAL_LIKE
  } from './../../types/paquetetypes';

const INITIAL_STATE = {
    isLoading: false,
    isLoadingIndi: false,

    valoracion: [],
    valoracionLoading: false,
    valoracionLoaded: false,
    valoracionError:'',

    paquetes: null,
    paquetegeneral: null,
    paquetesindi : null,
    paquetesindi2 : null,

    crearpaquete: null,
    fichaspaquete: [],
    versionpaquete: [],

    crearversion: [],
    loadingV:false,

    created: false,
    colaboradorpaquete: [],
    compradorpaquete: [],
    error: '',

    paquetehome: [],
    paquetehome_loaded:false,
    paquetehome_loading:false,
    paquetehome_error:'',

    individualp: [],
    individualp_loaded:false,
    individualp_loading:false,
    individualp_error:'',
    
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case VALORACION_LOADING:
            return {
                ... state,
                valoracion: [],
                valoracionLoading:true,
                valoracionLoaded:false,
                valoracionError:'',
            }
        case VALORACION_LOADED:
            return {
                ...state,
                valoracion: action.payload,
                valoracionLoaded:true,
                valoracionLoading:false,
                valoracionError:'',
            };
        case VALORACION_ERROR:
            return {
                ...state,
                valoracion: [],
                valoracionLoaded:false,
                valoracionLoading:false,
                valoracionError:action.payload,
            }
        case VALORACION_PAQUETE_LIKE:
            const { paqueteId, has_liked, total_likes } = action.payload;
            return {
                ...state,
                paquetegeneral: {
                    ...state.paquetegeneral,
                    results: state.paquetegeneral.results.map(paquete => 
                        paquete.id === paqueteId 
                            ? { 
                                ...paquete, 
                                total_likes,
                                has_liked
                            } 
                            : paquete
                    )
                }
            };
        case VALORACION_PAQUETE_INDIVIDUAL_LIKE:
            return {
                ...state,
                individualp: {
                    ...state.individualp,
                    has_liked: action.payload.has_liked,
                    total_likes: action.payload.total_likes
                }
            };
        case REVERTIR_VALORACION_LIKE:
            return {
                ...state,
                paquetegeneral: action.payload,
                individualp: action.payload.individualp
            };
        case PAQUETE_INDIVIDUAL_LOADING:
            return {
                ... state,
                individualp: [],
                individualp_loaded:false,
                individualp_loading:true,
                individualp_error:'',
            }
        case PAQUETE_INDIVIDUAL_LOADED:
            return {
                ...state,
                individualp: action.payload,
                individualp_loaded:true,
                individualp_loading:false,
                individualp_error:'',
            };
        case PAQUETE_INDIVIDUAL_ERROR:
            return {
                ...state,
                individualp: [],
                individualp_loaded:false,
                individualp_loading:false,
                individualp_error:action.payload,
            }

        case PAQUETE_HOME_LOADING:
            return {
                ... state,
                paquetehome_loading : true,
                paquetehome_error: ''
            }
        case PAQUETE_HOME_LOADED:
            return {
                ...state,
                paquetehome_loading : false,
                paquetehome: action.payload,
                paquetehome_loaded: true,
                paquetehome_error: ''
            };
        case PAQUETE_HOME_ERROR:
            return {
                ... state,
                paquetehome_loading : false,
                paquetehome_loaded: false,
                paquetehome_error: action.payload
            }

        case CREAR_VERSION_PAQUETE_LOADING:
            return {
                ... state,
                loadingV : true,
                error: ''
            }
        case CREAR_VERSION_PAQUETE_LOADED:
            return {
                ...state,
                loadingV : false,
                crearversion: action.payload,
                createdV: true,
                error: ''
            };
        case CREAR_VERSION_PAQUETE_ERROR:
            return {
                ... state,
                loadingV : false,
                createdV: false,
                error: action.payload
            }

        case COLABORADOR_PAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                error: ''
            }
        case COLABORADOR_PAQUETE_LOADED:
            return {
                ...state,
                isLoading : false,
                colaboradorpaquete: action.payload,
                error: ''
            };
        case COLABORADOR_PAQUETE_ERROR:
            return {
                ... state,
                isLoading : false,
                error: action.payload
            }

        case COMPRADOR_PAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                error: ''
            }
        case COMPRADOR_PAQUETE_LOADED:
            return {
                ...state,
                isLoading : false,
                compradorpaquete: action.payload,
                error: ''
            };
        case COMPRADOR_PAQUETE_ERROR:
            return {
                ... state,
                isLoading : false,
                error: action.payload
            }

        case VERSION_PAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                error: ''
            }
        case VERSION_PAQUETE_LOADED:
            return {
                ...state,
                isLoading : false,
                versionpaquete: action.payload,
                error: ''
            };
        case VERSION_PAQUETE_ERROR:
            return {
                ... state,
                isLoading : false,
                error: action.payload
            }

        case ESPECIE_PAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                error: ''
            }
        case ESPECIE_PAQUETE_LOADED:
            return {
                ...state,
                isLoading : false,
                fichaspaquete: action.payload,
                error: ''
            };
        case ESPECIE_PAQUETE_ERROR:
            return {
                ... state,
                isLoading : false,
                error: action.payload
            }

        case PAQUETEINDI2_LOADING:
            return {
                ... state,
                isLoading : true,
                paquetesindi2: null,
                paquetes: null,
                paquetesindi : null,
                crearpaquete: null,
                error: ''
            }
        case PAQUETEINDI2_LOADED:
            return {
                ...state,
                paquetesindi2: action.payload,
                paquetes: null,
                paquetesindi : null,
                crearpaquete: null,
                error: '',
                isLoading: false
            };
        case PAQUETEINDI2_ERROR:
            return {
                ...state,
                paquetesindi2: null,
                paquetes: null,
                paquetesindi : null,
                crearpaquete: null,
                isLoading: false,
                error: action.payload,
            }

        case PAQUETEINDI_LOADING:
            return {
                ... state,
                isLoadingIndi : true,
                paquetesindi: null,
                paquetesindi2: null,
                paquetes: null,
                crearpaquete: null,
                error: ''
            }
        case PAQUETEINDI_LOADED:
            return {
                ...state,
                paquetesindi: action.payload,
                paquetesindi2: null,
                paquetes: null,
                crearpaquete: null,
                error: '',
                isLoadingIndi: false
            };
        case PAQUETEINDI_ERROR:
            return {
                ...state,
                paquetesindi: null,
                paquetesindi2: null,
                paquetes: null,
                crearpaquete: null,
                isLoadingIndi: false,
                error: action.payload,
            }

        case PAQUETEGENERAL_LOADING:
            return {
                ... state,
                isLoading : true,
                paquetegeneral:null,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                crearpaquete: null,
                error: ''
            }
        case PAQUETEGENERAL_LOADED:
            return {
                ...state,
                paquetegeneral:action.payload,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                crearpaquete: null,
                error: '',
                isLoading: false
            };
        case PAQUETEGENERAL_ERROR:
            return {
                ...state,
                paquetegeneral:null,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                crearpaquete: null,
                isLoading: false,
                error: action.payload,
            }

        case PAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                crearpaquete: null,
                error: ''
            }
        case PAQUETE_LOADED:
            return {
                ...state,
                paquetes: action.payload,
                paquetesindi: null,
                paquetesindi2: null,
                crearpaquete: null,
                error: '',
                isLoading: false
            };
        case PAQUETE_ERROR:
            return {
                ...state,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                crearpaquete: null,
                isLoading: false,
                error: action.payload,
            }

        case CREARPAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearpaquete : null,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                error: ''
            }
        case CREARPAQUETE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearpaquete: action.payload,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                error: ''
            };
        case CREARPAQUETE_ERROR:
            return {
                ...state,
                crearpaquete : null,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                isLoading : false,
                error: action.payload,
            }

        case EDITARPAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearpaquete : null,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                error: ''
            }
        case EDITARPAQUETE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearpaquete: action.payload,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                error: ''
            };
        case EDITARPAQUETE_ERROR:
            return {
                ...state,
                crearpaquete : null,
                paquetes: null,
                paquetesindi: null,
                paquetesindi2: null,
                isLoading : false,
                error: action.payload,
            }

        case DELETEPAQUETE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearpaquete : null,
                error: ''
            }
        case DELETEPAQUETE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearpaquete: action.payload,
                error: ''
            };
        case DELETEPAQUETE_ERROR:
            return {
                ...state,
                crearpaquete : null,
                isLoading : false,
                error: action.payload,
            }
        default: return state;
    }
}